import axios from "axios";

interface StripePublicKeyResponse {
  stripePublicKey: string;
}

const getStripePublicKey = async (): Promise<StripePublicKeyResponse> => {
  // Configure the Axios request
  const config = {
    method: "get",
    url: `/api/config`,
    headers: {
      "Content-Type": "application/json",
    },
    maxRedirects: 5,
  };

  // Make the request
  return await axios(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(`Error getting stripe keys`, error); // Handle errors
      throw error; // Propagate error to the caller
    });
};

export { getStripePublicKey };
